var _path, _path2, _path3, _g, _path4, _path5, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallCycon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4228_10290)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90234 16.1982C13.3206 16.1982 16.9023 12.6165 16.9023 8.19824C16.9023 3.77996 13.3206 0.198242 8.90234 0.198242C4.48407 0.198242 0.902344 3.77996 0.902344 8.19824C0.902344 12.6165 4.48407 16.1982 8.90234 16.1982Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1461 4.31581L5.94673 10.3133C5.46074 11.0076 5.63098 11.9733 6.32528 12.4593C7.01959 12.9453 7.98502 12.7751 8.47101 12.0811L12.6707 6.08326C13.1566 5.38896 12.9864 4.42352 12.2924 3.93725C12.025 3.74996 11.7172 3.66016 11.4119 3.66016C10.9251 3.66016 10.4451 3.88894 10.1461 4.31553",
    fill: "#6150DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4228_10290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 8,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1461 4.31581L5.94673 10.3133C5.46074 11.0076 5.63098 11.9733 6.32528 12.4593C7.01959 12.9453 7.98502 12.7751 8.47101 12.0811L12.6707 6.08326C13.1566 5.38896 12.9864 4.42352 12.2924 3.93725C12.025 3.74996 11.7172 3.66016 11.4119 3.66016C10.9251 3.66016 10.4451 3.88894 10.1461 4.31553",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4228_10290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2398 11.4032L5.80127 12.917L5.84453 13.1581L14.2831 11.6444L14.2398 11.4032Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80324 12.9356L5.79443 12.885L14.233 11.3711L14.2421 11.4214L5.80324 12.9356Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79714 12.9017L5.78833 12.8511L14.2266 11.3369L14.2357 11.3875L5.79714 12.9017Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79132 12.8682L5.78223 12.8179L14.2207 11.3037L14.2298 11.3543L5.79132 12.8682Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78522 12.8341L5.77612 12.7838L14.2146 11.2695L14.2237 11.3198L5.78522 12.8341Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77911 12.8011L5.77002 12.7506L14.2088 11.2363L14.2176 11.2869L5.77911 12.8011Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77297 12.7667L5.76416 12.7164L14.2024 11.2021L14.2115 11.2527L5.77297 12.7667Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76715 12.7335L5.75806 12.6832L14.1966 11.1689L14.2057 11.2192L5.76715 12.7335Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76105 12.7003L5.75195 12.65L14.1905 11.1357L14.1996 11.186L5.76105 12.7003Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7549 12.6664L5.74609 12.6158L14.1846 11.1016L14.1934 11.1522L5.7549 12.6664Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7488 12.6329L5.73999 12.5826L14.1785 11.0684L14.1873 11.1189L5.7488 12.6329Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74294 12.5987L5.73413 12.5484L14.1724 11.0342L14.1815 11.0845L5.74294 12.5987Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73688 12.5655L5.72778 12.5149L14.1663 11.001L14.1754 11.0513L5.73688 12.5655Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73102 12.5316L5.72192 12.481L14.1604 10.9668L14.1695 11.0174L5.73102 12.5316Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72463 12.4981L5.71582 12.4478L14.1543 10.9336L14.1632 10.9842L5.72463 12.4981Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71877 12.4649L5.70996 12.4146L14.1482 10.9004L14.1573 10.9507L5.71877 12.4649Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71271 12.4307L5.70361 12.3802L14.1421 10.8662L14.1512 10.9165L5.71271 12.4307Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70685 12.3978L5.69775 12.3472L14.1363 10.833L14.1454 10.8836L5.70685 12.3978Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7007 12.3634L5.69189 12.3131L14.1304 10.7988L14.1392 10.8491L5.7007 12.3634Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6946 12.3302L5.68579 12.2796L14.124 10.7656L14.1334 10.8159L5.6946 12.3302Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68854 12.2963L5.67944 12.2457L14.118 10.7314L14.1271 10.782L5.68854 12.2963Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68268 12.2631L5.67358 12.2125L14.1121 10.6982L14.1212 10.7488L5.68268 12.2631Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67682 12.2296L5.66772 12.1793L14.1062 10.665L14.1151 10.7153L5.67682 12.2296Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67043 12.1954L5.66162 12.1448L14.1001 10.6309L14.109 10.6812L5.67043 12.1954Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66457 12.1625L5.65576 12.1119L14.094 10.5977L14.1034 10.6482L5.66457 12.1625Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65851 12.128L5.64941 12.0777L14.0879 10.5635L14.097 10.6141L5.65851 12.128Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65265 12.0948L5.64355 12.0445L14.0821 10.5303L14.0909 10.5806L5.65265 12.0948Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64626 12.0616L5.63745 12.011L14.076 10.4971L14.0848 10.5474L5.64626 12.0616Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6404 12.0277L5.63159 11.9771L14.0701 10.4629L14.0789 10.5135L5.6404 12.0277Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63434 11.9942L5.62524 11.9439L14.0638 10.4297L14.0729 10.4803L5.63434 11.9942Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62848 11.96L5.61938 11.9095L14.0579 10.3955L14.067 10.4458L5.62848 11.96Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62238 11.9271L5.61328 11.8765L14.0518 10.3623L14.0606 10.4129L5.62238 11.9271Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61623 11.8929L5.60742 11.8424L14.0459 10.3281L14.0548 10.3787L5.61623 11.8929Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61013 11.8595L5.60132 11.8091L14.0396 10.2949L14.0489 10.3452L5.61013 11.8595Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60431 11.8263L5.59521 11.7757L14.0337 10.2617L14.0428 10.312L5.60431 11.8263Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59821 11.7924L5.58911 11.7418L14.0276 10.2275L14.0364 10.2781L5.59821 11.7924Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59206 11.7589L5.58325 11.7086L14.0218 10.1943L14.0309 10.2449L5.59206 11.7589Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58596 11.7247L5.57715 11.6744L14.0157 10.1602L14.0245 10.2105L5.58596 11.7247Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58014 11.6915L5.57104 11.6409L14.0096 10.127L14.0187 10.1773L5.58014 11.6915Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57404 11.6586L5.56494 11.608L14.0035 10.0938L14.0126 10.1443L5.57404 11.6586Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56818 11.6241L5.55908 11.5738L13.9976 10.0596L14.0064 10.1099L5.56818 11.6241Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56179 11.5909L5.55298 11.5406L13.9915 10.0264L14.0003 10.0767L5.56179 11.5909Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55593 11.557L5.54712 11.5064L13.9856 9.99219L13.9945 10.0428L5.55593 11.557Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54987 11.5238L5.54077 11.4732L13.9793 9.95898L13.9884 10.0096L5.54987 11.5238Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54401 11.4903L5.53491 11.44L13.9734 9.92578L13.9825 9.97608L5.54401 11.4903Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53786 11.4564L5.52905 11.4058L13.9676 9.8916L13.9767 9.94219L5.53786 11.4564Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53176 11.4232L5.52295 11.3726L13.9615 9.8584L13.9703 9.90899L5.53176 11.4232Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5257 11.3887L5.5166 11.3384L13.9551 9.82422L13.9642 9.87481L5.5257 11.3887Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51984 11.3555L5.51074 11.3052L13.9493 9.79102L13.9584 9.84132L5.51984 11.3555Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51398 11.3217L5.50488 11.2711L13.9434 9.75684L13.9522 9.80742L5.51398 11.3217Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50759 11.2884L5.49878 11.2379L13.9373 9.72363L13.9461 9.77422L5.50759 11.2884Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50173 11.255L5.49292 11.2047L13.9312 9.69043L13.9403 9.74073L5.50173 11.255Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49567 11.2208L5.48657 11.1705L13.9251 9.65625L13.9342 9.70655L5.49567 11.2208Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48981 11.1879L5.48071 11.1373L13.9192 9.62305L13.9283 9.67363L5.48981 11.1879Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4837 11.1537L5.47461 11.1031L13.9131 9.58887L13.9219 9.63946L5.4837 11.1537Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47756 11.1202L5.46875 11.0699L13.9073 9.55566L13.9161 9.60597L5.47756 11.1202Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4715 11.087L5.4624 11.0364L13.9009 9.52246L13.91 9.57276L5.4715 11.087Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46564 11.0531L5.45654 11.0025L13.8951 9.48828L13.9042 9.53887L5.46564 11.0531Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45953 11.0196L5.45044 10.9693L13.889 9.45508L13.8978 9.50538L5.45953 11.0196Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45339 10.9854L5.44458 10.9351L13.8831 9.4209L13.8919 9.4712L5.45339 10.9854Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44733 10.9525L5.43823 10.9019L13.8768 9.3877L13.8858 9.43828L5.44733 10.9525Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44147 10.9183L5.43237 10.8677L13.8709 9.35352L13.88 9.4041L5.44147 10.9183Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43536 10.8848L5.42627 10.8345L13.8648 9.32031L13.8736 9.37062L5.43536 10.8848Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4295 10.8516L5.42041 10.8013L13.8589 9.28711L13.8677 9.33741L5.4295 10.8516Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42312 10.8177L5.41431 10.7672L13.8528 9.25293L13.8616 9.30352L5.42312 10.8177Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4173 10.7843L5.4082 10.734L13.8467 9.21973L13.8558 9.27031L5.4173 10.7843Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41119 10.7501L5.4021 10.6998L13.8406 9.18555L13.8497 9.23585L5.41119 10.7501Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40533 10.7169L5.39624 10.6663L13.8348 9.15234L13.8436 9.20265L5.40533 10.7169Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39895 10.683L5.39014 10.6324L13.8287 9.11816L13.8378 9.16875L5.39895 10.683Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39313 10.6495L5.38403 10.5992L13.8226 9.08496L13.8317 9.13527L5.39313 10.6495Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38702 10.6163L5.37793 10.566L13.8165 9.05176L13.8255 9.10206L5.38702 10.6163Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38116 10.5824L5.37207 10.5318L13.8106 9.01758L13.8197 9.06817L5.38116 10.5824Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37506 10.5492L5.36597 10.4986L13.8045 8.98438L13.8133 9.03496L5.37506 10.5492Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36892 10.5147L5.36011 10.4644L13.7983 8.9502L13.8074 9.0005L5.36892 10.5147Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36285 10.4815L5.35376 10.4312L13.7923 8.91699L13.8014 8.9673L5.36285 10.4815Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.357 10.4476L5.3479 10.397L13.7864 8.88281L13.7955 8.9334L5.357 10.4476Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35114 10.4141L5.34204 10.3638L13.7806 8.84961L13.7894 8.9002L5.35114 10.4141Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34475 10.3809L5.33594 10.3306L13.7745 8.81641L13.7836 8.86671L5.34475 10.3809Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33889 10.347L5.33008 10.2965L13.7683 8.78223L13.7774 8.83281L5.33889 10.347Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33282 10.3138L5.32373 10.2633L13.7623 8.74902L13.7713 8.79961L5.33282 10.3138Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32697 10.2794L5.31787 10.2291L13.7564 8.71484L13.7655 8.76543L5.32697 10.2794Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32058 10.2462L5.31177 10.1959L13.7503 8.68164L13.7591 8.73194L5.32058 10.2462Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31472 10.2123L5.30591 10.1617L13.7441 8.64746L13.7532 8.69805L5.31472 10.2123Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30866 10.1791L5.29956 10.1285L13.7381 8.61426L13.7472 8.66485L5.30866 10.1791Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3028 10.1456L5.2937 10.0953L13.7322 8.58105L13.7413 8.63136L5.3028 10.1456Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29669 10.1114L5.2876 10.0608L13.7261 8.54688L13.7352 8.59718L5.29669 10.1114Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29055 10.0785L5.28174 10.0279L13.7203 8.51367L13.7291 8.56426L5.29055 10.0785Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28444 10.044L5.27563 9.99372L13.7139 8.47949L13.723 8.53008L5.28444 10.044Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27863 10.0108L5.26953 9.96052L13.7081 8.44629L13.7171 8.49659L5.27863 10.0108Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27252 9.97762L5.26343 9.92703L13.702 8.41309L13.711 8.46339L5.27252 9.97762Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26638 9.94372L5.25757 9.89313L13.6961 8.37891L13.7049 8.42949L5.26638 9.94372Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26028 9.91023L5.25146 9.85993L13.6897 8.3457L13.6988 8.39629L5.26028 9.91023Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25446 9.87605L5.24536 9.82575L13.6839 8.31152L13.693 8.36183L5.25446 9.87605Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24835 9.84314L5.23926 9.79255L13.6778 8.27832L13.6869 8.32891L5.24835 9.84314Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24249 9.80896L5.2334 9.75837L13.6719 8.24414L13.6807 8.29473L5.24249 9.80896Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23611 9.77547L5.22729 9.72517L13.6658 8.21094L13.6746 8.26124L5.23611 9.77547Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23025 9.74227L5.22144 9.69168L13.6597 8.17773L13.6688 8.22804L5.23025 9.74227Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22418 9.70837L5.21509 9.65778L13.6536 8.14355L13.6627 8.19414L5.22418 9.70837Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21832 9.67488L5.20923 9.62458L13.6478 8.11035L13.6568 8.16094L5.21832 9.67488Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21194 9.6407L5.20312 9.5904L13.6416 8.07617L13.6505 8.12648L5.21194 9.6407Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20608 9.6075L5.19727 9.55691L13.6355 8.04297L13.6449 8.09327L5.20608 9.6075Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20022 9.57361L5.19141 9.52302L13.6296 8.00879L13.6387 8.05938L5.20022 9.57361Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19415 9.54012L5.18506 9.48981L13.6236 7.97559L13.6327 8.02589L5.19415 9.54012Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18801 9.50691L5.1792 9.45661L13.6177 7.94238L13.6268 7.99269L5.18801 9.50691Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18191 9.47302L5.1731 9.42243L13.6116 7.9082L13.6204 7.95879L5.18191 9.47302Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17605 9.43982L5.16724 9.38923L13.6055 7.875L13.6146 7.92559L5.17605 9.43982Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16998 9.40535L5.16089 9.35505L13.5994 7.84082L13.6085 7.89112L5.16998 9.40535Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16412 9.37215L5.15503 9.32156L13.5936 7.80762L13.6026 7.85792L5.16412 9.37215Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15774 9.33825L5.14893 9.28767L13.5875 7.77344L13.5965 7.82403L5.15774 9.33825Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15188 9.30477L5.14307 9.25446L13.5813 7.74023L13.5907 7.79082L5.15188 9.30477Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14581 9.27156L5.13672 9.22126L13.5752 7.70703L13.5843 7.75733L5.14581 9.27156Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13995 9.23738L5.13086 9.18679L13.5694 7.67285L13.5785 7.72315L5.13995 9.23738Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13357 9.20446L5.12476 9.15388L13.5633 7.63965L13.5724 7.69024L5.13357 9.20446Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12771 9.17L5.1189 9.1197L13.5574 7.60547L13.5662 7.65606L5.12771 9.17Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1216 9.1368L5.11279 9.08649L13.551 7.57227L13.5601 7.62257L5.1216 9.1368Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11578 9.10359L5.10669 9.05301L13.5452 7.53906L13.5543 7.58937L5.11578 9.10359Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10968 9.0697L5.10059 9.01911L13.5391 7.50488L13.5482 7.55547L5.10968 9.0697Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10354 9.03621L5.09473 8.98591L13.5332 7.47168L13.5423 7.52198L5.10354 9.03621Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09743 9.00203L5.08862 8.95173L13.5271 7.4375L13.536 7.4878L5.09743 9.00203Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09161 8.96911L5.08252 8.91853L13.521 7.4043L13.5301 7.45489L5.09161 8.96911Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08551 8.93563L5.07642 8.88532L13.5149 7.37109L13.524 7.42168L5.08551 8.93563Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07969 8.90145L5.07031 8.85114L13.5091 7.33691L13.5179 7.38722L5.07969 8.90145Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07326 8.86824L5.06445 8.81765L13.503 7.30371L13.5118 7.35401L5.07326 8.86824Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0674 8.83435L5.05859 8.78376L13.4968 7.26953L13.5059 7.32012L5.0674 8.83435Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06134 8.80086L5.05225 8.75056L13.4908 7.23633L13.4999 7.28692L5.06134 8.80086Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05548 8.76766L5.04639 8.71735L13.4849 7.20312L13.4937 7.25343L5.05548 8.76766Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04909 8.73376L5.04028 8.68317L13.4788 7.16895L13.4876 7.21953L5.04909 8.73376Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04323 8.70056L5.03442 8.64997L13.4729 7.13574L13.4818 7.18633L5.04323 8.70056Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03717 8.66609L5.02808 8.61579L13.4666 7.10156L13.4757 7.15187L5.03717 8.66609Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03131 8.63289L5.02222 8.58259L13.4607 7.06836L13.4698 7.11866L5.03131 8.63289Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02521 8.599L5.01611 8.54841L13.4546 7.03418L13.4634 7.08477L5.02521 8.599Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01906 8.56579L5.01025 8.5152L13.4488 7.00098L13.4576 7.05156L5.01906 8.56579Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.013 8.53231L5.00391 8.482L13.4424 6.96777L13.4515 7.01808L5.013 8.53231Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00714 8.49813L4.99805 8.44754L13.4366 6.93359L13.4457 6.9839L5.00714 8.49813Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00128 8.46521L4.99219 8.41462L13.4307 6.90039L13.4395 6.95098L5.00128 8.46521Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99489 8.43074L4.98608 8.38044L13.4246 6.86621L13.4337 6.9168L4.99489 8.43074Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98903 8.39754L4.98022 8.34724L13.4185 6.83301L13.4276 6.88331L4.98903 8.39754Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98297 8.36364L4.97388 8.31306L13.4124 6.79883L13.4215 6.84942L4.98297 8.36364Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97711 8.33044L4.96802 8.27985L13.4065 6.76562L13.4156 6.81621L4.97711 8.33044Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97101 8.29695L4.96191 8.24665L13.4004 6.73242L13.4092 6.78273L4.97101 8.29695Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96486 8.26277L4.95605 8.21247L13.3946 6.69824L13.4034 6.74855L4.96486 8.26277Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9588 8.22985L4.94971 8.17927L13.3882 6.66504L13.3973 6.71563L4.9588 8.22985Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95294 8.19568L4.94385 8.14509L13.3824 6.63086L13.3915 6.68145L4.95294 8.19568Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94684 8.16219L4.93774 8.11188L13.3763 6.59766L13.3851 6.64796L4.94684 8.16219Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9407 8.12898L4.93188 8.0784L13.3704 6.56445L13.3795 6.61476L4.9407 8.12898Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93459 8.09509L4.92578 8.0445L13.364 6.53027L13.3731 6.58086L4.93459 8.09509Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92877 8.0616L4.91968 8.0113L13.3582 6.49707L13.3673 6.54737L4.92877 8.0616Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92267 8.02742L4.91357 7.97712L13.3521 6.46289L13.3612 6.51319L4.92267 8.02742Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91681 7.9945L4.90771 7.94392L13.3462 6.42969L13.355 6.48028L4.91681 7.9945Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91042 7.96032L4.90161 7.90974L13.3399 6.39551L13.3492 6.4461L4.91042 7.96032Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90456 7.92684L4.89575 7.87653L13.334 6.3623L13.3431 6.41261L4.90456 7.92684Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8985 7.89363L4.8894 7.84333L13.3279 6.3291L13.337 6.37941L4.8985 7.89363Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89264 7.85974L4.88354 7.80915L13.3221 6.29492L13.3309 6.34551L4.89264 7.85974Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88658 7.82625L4.8772 7.77595L13.316 6.26172L13.3248 6.31231L4.88658 7.82625Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88039 7.79207L4.87158 7.74177L13.3098 6.22754L13.3189 6.27784L4.88039 7.79207Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87433 7.75887L4.86523 7.70828L13.3038 6.19434L13.3129 6.24464L4.87433 7.75887Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86847 7.72497L4.85938 7.67438L13.2979 6.16016L13.307 6.21074L4.86847 7.72497Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86237 7.69148L4.85327 7.64118L13.2918 6.12695L13.3006 6.17754L4.86237 7.69148Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85622 7.65828L4.84741 7.60798L13.2859 6.09375L13.2947 6.14405L4.85622 7.65828Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85036 7.62439L4.84155 7.5738L13.2798 6.05957L13.2889 6.11016L4.85036 7.62439Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8443 7.59118L4.83521 7.54059L13.2737 6.02637L13.2828 6.07696L4.8443 7.59118Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83844 7.55672L4.82935 7.50642L13.2679 5.99219L13.277 6.04249L4.83844 7.55672Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83234 7.52352L4.82324 7.47321L13.2618 5.95898L13.2706 6.00929L4.83234 7.52352Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82619 7.48962L4.81738 7.43903L13.2556 5.9248L13.2647 5.97539L4.82619 7.48962Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82013 7.45613L4.81104 7.40583L13.2496 5.8916L13.2587 5.94219L4.82013 7.45613Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81427 7.42293L4.80518 7.37263L13.2437 5.8584L13.2528 5.9087L4.81427 7.42293Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80817 7.38875L4.79907 7.33816L13.2376 5.82422L13.2464 5.87452L4.80817 7.38875Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80202 7.35583L4.79321 7.30524L13.2317 5.79102L13.2408 5.8416L4.80202 7.35583Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79592 7.32137L4.78711 7.27106L13.2253 5.75684L13.2344 5.80742L4.79592 7.32137Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7901 7.28816L4.78101 7.23786L13.2195 5.72363L13.2286 5.77394L4.7901 7.28816Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.784 7.25427L4.7749 7.20368L13.2134 5.68945L13.2225 5.74004L4.784 7.25427Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77785 7.22107L4.76904 7.17048L13.2076 5.65625L13.2164 5.70684L4.77785 7.22107Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77175 7.18758L4.76294 7.13727L13.2012 5.62305L13.2106 5.67335L4.77175 7.18758Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76593 7.1534L4.75684 7.10281L13.1954 5.58887L13.2045 5.63917L4.76593 7.1534Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75983 7.12048L4.75073 7.06989L13.1893 5.55566L13.1983 5.60625L4.75983 7.12048Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75397 7.08602L4.74487 7.03571L13.1834 5.52148L13.1922 5.57207L4.75397 7.08602Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74758 7.05281L4.73877 7.00251L13.1773 5.48828L13.1864 5.53858L4.74758 7.05281Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74172 7.01961L4.73291 6.96902L13.1712 5.45508L13.1802 5.50538L4.74172 7.01961Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73566 6.98571L4.72656 6.93513L13.1651 5.4209L13.1742 5.47149L4.73566 6.98571Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7298 6.95223L4.7207 6.90192L13.1592 5.3877L13.1683 5.438L4.7298 6.95223Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72341 6.91805L4.7146 6.86774L13.1531 5.35352L13.1619 5.40382L4.72341 6.91805Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71755 6.88513L4.70874 6.83454L13.147 5.32031L13.1564 5.3709L4.71755 6.88513Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71149 6.85095L4.70239 6.80036L13.1409 5.28613L13.15 5.33672L4.71149 6.85095Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70563 6.81746L4.69653 6.76716L13.1351 5.25293L13.1442 5.30323L4.70563 6.81746Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69924 6.78426L4.69043 6.73367L13.129 5.21973L13.138 5.27003L4.69924 6.78426Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69342 6.75036L4.68433 6.69977L13.1231 5.18555L13.1319 5.23613L4.69342 6.75036Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68752 6.71716L4.67871 6.66657L13.117 5.15234L13.126 5.20293L4.68752 6.71716Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68146 6.6827L4.67236 6.63239L13.1109 5.11816L13.12 5.16847L4.68146 6.6827Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67535 6.64949L4.66626 6.5989L13.1048 5.08496L13.1139 5.13526L4.67535 6.64949Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66921 6.6156L4.6604 6.56501L13.0989 5.05078L13.1077 5.10137L4.66921 6.6156Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66335 6.58211L4.65454 6.53181L13.0928 5.01758L13.1019 5.06788L4.66335 6.58211Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65729 6.54891L4.64819 6.4986L13.0867 4.98438L13.0958 5.03468L4.65729 6.54891Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65143 6.51501L4.64233 6.46442L13.0809 4.9502L13.09 5.00078L4.65143 6.51501Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64504 6.48181L4.63623 6.43122L13.0748 4.91699L13.0838 4.96758L4.64504 6.48181Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63918 6.44734L4.63037 6.39704L13.0689 4.88281L13.0777 4.93312L4.63918 6.44734Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63312 6.41414L4.62402 6.36355L13.0625 4.84961L13.0716 4.89991L4.63312 6.41414Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62726 6.38122L4.61816 6.33063L13.0567 4.81641L13.0658 4.86699L4.62726 6.38122Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62116 6.34676L4.61206 6.29645L13.0506 4.78223L13.0594 4.83281L4.62116 6.34676Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61501 6.31356L4.6062 6.26325L13.0447 4.74902L13.0535 4.79933L4.61501 6.31356Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60891 6.27938L4.6001 6.22879L13.0383 4.71484L13.0477 4.76515L4.60891 6.27938Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60309 6.24646L4.59399 6.19587L13.0325 4.68164L13.0416 4.73223L4.60309 6.24646Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59698 6.21297L4.58789 6.16267L13.0264 4.64844L13.0352 4.69874L4.59698 6.21297Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59113 6.17879L4.58203 6.12849L13.0206 4.61426L13.0294 4.66456L4.59113 6.17879Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58474 6.14587L4.57593 6.09528L13.0145 4.58105L13.0233 4.63164L4.58474 6.14587Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57892 6.11169L4.56982 6.0611L13.0083 4.54688L13.0174 4.59746L4.57892 6.11169Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57282 6.0782L4.56372 6.0279L13.0022 4.51367L13.0113 4.56398L4.57282 6.0782Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56696 6.045L4.55786 5.99441L12.9964 4.48047L13.0052 4.53077L4.56696 6.045Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56057 6.0111L4.55176 5.96052L12.9903 4.44629L12.9991 4.49688L4.56057 6.0111Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55471 5.97762L4.5459 5.92731L12.9841 4.41309L12.9935 4.46367L4.55471 5.97762Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54865 5.94344L4.53955 5.89313L12.9781 4.37891L12.9872 4.42921L4.54865 5.94344Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54279 5.91023L4.53369 5.85965L12.9722 4.3457L12.981 4.39601L4.54279 5.91023Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5364 5.87634L4.52759 5.82575L12.9661 4.31152L12.9752 4.36211L4.5364 5.87634Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53054 5.84285L4.52173 5.79255L12.9603 4.27832L12.9691 4.32891L4.53054 5.84285Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52448 5.80965L4.51538 5.75935L12.9539 4.24512L12.963 4.29542L4.52448 5.80965Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51862 5.77575L4.50952 5.72517L12.948 4.21094L12.9571 4.26153L4.51862 5.77575Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51251 5.74227L4.50342 5.69196L12.9419 4.17773L12.9508 4.22832L4.51251 5.74227Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50637 5.70809L4.49756 5.65778L12.9361 4.14355L12.9449 4.19386L4.50637 5.70809Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50051 5.67488L4.4917 5.6243L12.9299 4.11035L12.939 4.16066L4.50051 5.67488Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49445 5.64099L4.48535 5.5904L12.9239 4.07617L12.933 4.12676L4.49445 5.64099Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48859 5.6075L4.47949 5.5572L12.918 4.04297L12.9268 4.09356L4.48859 5.6075Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4822 5.5743L4.47339 5.52399L12.9119 4.00977L12.921 4.06007L4.4822 5.5743Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47634 5.54012L4.46753 5.48953L12.9061 3.97559L12.9149 4.02589L4.47634 5.54012Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47028 5.5072L4.46118 5.45661L12.8997 3.94238L12.9088 3.99297L4.47028 5.5072Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46442 5.47273L4.45532 5.42243L12.8938 3.9082L12.9029 3.95879L4.46442 5.47273Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45831 5.43953L4.44922 5.38923L12.8877 3.875L12.8966 3.9253L4.45831 5.43953Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45217 5.40564L4.44336 5.35505L12.8819 3.84082L12.891 3.89141L4.45217 5.40564Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44607 5.37243L4.43726 5.32185L12.8755 3.80762L12.8846 3.85821L4.44607 5.37243Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44025 5.33895L4.43115 5.28864L12.8697 3.77441L12.8788 3.82472L4.44025 5.33895Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43414 5.30477L4.42505 5.25446L12.8636 3.74023L12.8727 3.79054L4.43414 5.30477Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42828 5.27185L4.41919 5.22126L12.8577 3.70703L12.8665 3.75762L4.42828 5.27185Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4219 5.23738L4.41309 5.18708L12.8516 3.67285L12.8604 3.72344L4.4219 5.23738Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41608 5.20418L4.40698 5.15388L12.8455 3.63965L12.8546 3.68995L4.41608 5.20418Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40997 5.17028L4.40088 5.1197L12.8394 3.60547L12.8485 3.65606L4.40997 5.17028Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40411 5.13708L4.39502 5.08649L12.8335 3.57227L12.8424 3.62285L4.40411 5.13708Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39773 5.10359L4.38892 5.05329L12.8274 3.53906L12.8365 3.58965L4.39773 5.10359Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39187 5.06941L4.38306 5.01911L12.8213 3.50488L12.8304 3.55519L4.39187 5.06941Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3858 5.0365L4.37671 4.98591L12.8152 3.47168L12.8243 3.52227L4.3858 5.0365Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37994 5.00232L4.37085 4.95173L12.8094 3.4375L12.8185 3.48809L4.37994 5.00232Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37384 4.96883L4.36475 4.91852L12.8033 3.4043L12.8121 3.4546L4.37384 4.96883Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3677 4.93563L4.35889 4.88504L12.7974 3.37109L12.8062 3.4214L4.3677 4.93563Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36163 4.90173L4.35254 4.85114L12.7911 3.33691L12.8002 3.3875L4.36163 4.90173Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35577 4.86824L4.34668 4.81794L12.7852 3.30371L12.7943 3.3543L4.35577 4.86824Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34967 4.83406L4.34058 4.78376L12.7791 3.26953L12.7879 3.31983L4.34967 4.83406Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34353 4.80086L4.33472 4.75027L12.7732 3.23633L12.7823 3.28663L4.34353 4.80086Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33756 4.76716L4.33472 4.75153L12.7735 3.2373L12.7761 3.25294L4.33756 4.76716Z",
    fill: "#6150DC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85693 5.2011C4.85693 6.04859 5.55039 6.74204 6.39788 6.74204C7.24537 6.74204 7.93882 6.04887 7.93882 5.2011C7.93882 4.35332 7.24537 3.66016 6.39788 3.66016C5.55039 3.66016 4.85693 4.35361 4.85693 5.2011Z",
    fill: "#6150DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4228_10290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 4,
    height: 4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85693 5.2011C4.85693 6.04859 5.55039 6.74204 6.39788 6.74204C7.24537 6.74204 7.93882 6.04887 7.93882 5.2011C7.93882 4.35332 7.24537 3.66016 6.39788 3.66016C5.55039 3.66016 4.85693 4.35361 4.85693 5.2011Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4228_10290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.052 7.13546L5.05371 7.1454L8.33397 6.55682L8.33226 6.54688L5.052 7.13546Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05695 7.16261L5.04785 7.11202L8.32811 6.52344L8.3372 6.57403L5.05695 7.16261Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05056 7.12843L5.04175 7.07784L8.32172 6.48926L8.33082 6.53985L5.05056 7.12843Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0447 7.09494L5.03589 7.04464L8.31586 6.45605L8.32496 6.50636L5.0447 7.09494Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03864 7.06174L5.02954 7.01115L8.3098 6.42285L8.31861 6.47316L5.03864 7.06174Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03278 7.02784L5.02368 6.97725L8.30394 6.38867L8.31304 6.43926L5.03278 7.02784Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02667 6.99435L5.01758 6.94405L8.29784 6.35547L8.30665 6.40577L5.02667 6.99435Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02053 6.96017L5.01172 6.90987L8.29169 6.32129L8.30079 6.37159L5.02053 6.96017Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01467 6.92697L5.00586 6.87638L8.28583 6.28809L8.29493 6.33839L5.01467 6.92697Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00861 6.89308L4.99951 6.84249L8.27977 6.25391L8.28858 6.30449L5.00861 6.89308Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0025 6.85959L4.99341 6.80929L8.27367 6.2207L8.28276 6.27129L5.0025 6.85959Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99664 6.82639L4.98755 6.77608L8.26781 6.1875L8.27662 6.2378L4.99664 6.82639Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9905 6.79221L4.98169 6.74162L8.26166 6.15332L8.27076 6.20362L4.9905 6.79221Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98444 6.759L4.97534 6.7087L8.2556 6.12012L8.26469 6.17071L4.98444 6.759Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97858 6.72482L4.96948 6.67452L8.24974 6.08594L8.25855 6.13624L4.97858 6.72482Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97247 6.69162L4.96338 6.64103L8.24364 6.05273L8.25245 6.10304L4.97247 6.69162Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96633 6.65772L4.95752 6.60714L8.23749 6.01855L8.24659 6.06914L4.96633 6.65772Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96023 6.62424L4.95142 6.57393L8.23139 5.98535L8.24048 6.03565L4.96023 6.62424Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95441 6.59103L4.94531 6.54073L8.22557 5.95215L8.23438 6.00245L4.95441 6.59103Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9483 6.55685L4.93921 6.50627L8.21947 5.91797L8.22828 5.96827L4.9483 6.55685Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94244 6.52394L4.93335 6.47335L8.21361 5.88477L8.22242 5.93535L4.94244 6.52394Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93606 6.48947L4.92725 6.43917L8.20722 5.85059L8.21631 5.90117L4.93606 6.48947Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93024 6.45627L4.92114 6.40596L8.2014 5.81738L8.2105 5.86769L4.93024 6.45627Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92413 6.42237L4.91504 6.37179L8.1953 5.7832L8.20411 5.83379L4.92413 6.42237Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91827 6.38889L4.90918 6.33858L8.18944 5.75L8.19825 5.80059L4.91827 6.38889Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91189 6.35568L4.90308 6.30538L8.18305 5.7168L8.19215 5.7671L4.91189 6.35568Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90603 6.3215L4.89722 6.27092L8.17719 5.68262L8.18629 5.73292L4.90603 6.3215Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89996 6.28858L4.89087 6.238L8.17113 5.64941L8.17994 5.7L4.89996 6.28858Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8941 6.25412L4.88501 6.20382L8.16527 5.61523L8.17408 5.66582L4.8941 6.25412Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.888 6.22092L4.87891 6.17061L8.15888 5.58203L8.16798 5.63234L4.888 6.22092Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88186 6.18771L4.87305 6.13713L8.15302 5.54883L8.16212 5.59913L4.88186 6.18771Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87575 6.15382L4.86694 6.10323L8.14692 5.51465L8.15601 5.56524L4.87575 6.15382Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86993 6.12033L4.86084 6.07003L8.1411 5.48145L8.14991 5.53203L4.86993 6.12033Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86383 6.08615L4.85474 6.03585L8.13471 5.44727L8.14409 5.49757L4.86383 6.08615Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85769 6.05323L4.84888 6.00264L8.12885 5.41406L8.13795 5.46465L4.85769 6.05323Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85183 6.01877L4.84302 5.96847L8.12299 5.37988L8.13209 5.43047L4.85183 6.01877Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84576 5.98557L4.83667 5.93526L8.11693 5.34668L8.12602 5.39698L4.84576 5.98557Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83966 5.95236L4.83057 5.90177L8.11083 5.31348L8.11992 5.36378L4.83966 5.95236Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83352 5.91847L4.82471 5.86788L8.10468 5.2793L8.11378 5.32989L4.83352 5.91847Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82766 5.88498L4.81885 5.83468L8.09882 5.24609L8.10792 5.29668L4.82766 5.88498Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82155 5.8508L4.81274 5.8005L8.09272 5.21191L8.10181 5.26222L4.82155 5.8508Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81573 5.8176L4.80664 5.76701L8.0869 5.17871L8.09571 5.22901L4.81573 5.8176Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80963 5.7837L4.80054 5.73311L8.08051 5.14453L8.08989 5.19512L4.80963 5.7837Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80349 5.75021L4.79468 5.69991L8.07465 5.11133L8.08375 5.16192L4.80349 5.75021Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79738 5.71701L4.78857 5.66671L8.06855 5.07812L8.07764 5.12843L4.79738 5.71701Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79157 5.68312L4.78247 5.63253L8.06273 5.04395L8.07182 5.09453L4.79157 5.68312Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78546 5.64991L4.77637 5.59932L8.05663 5.01074L8.06544 5.06133L4.78546 5.64991Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77932 5.61643L4.77051 5.56612L8.05048 4.97754L8.05958 5.02784L4.77932 5.61643Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77321 5.58225L4.7644 5.53166L8.04438 4.94336L8.05347 4.99366L4.77321 5.58225Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76736 5.54933L4.75854 5.49874L8.03852 4.91016L8.04761 4.96046L4.76736 5.54933Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76129 5.51486L4.7522 5.46456L8.03246 4.87598L8.04127 4.92656L4.76129 5.51486Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75543 5.48166L4.74634 5.43136L8.02631 4.84277L8.03569 4.89308L4.75543 5.48166Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74904 5.44846L4.74023 5.39787L8.02021 4.80957L8.0293 4.85959L4.74904 5.44846Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74319 5.41456L4.73438 5.36397L8.01435 4.77539L8.02344 4.82598L4.74319 5.41456Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73712 5.38107L4.72803 5.33077L8.00829 4.74219L8.01738 4.79278L4.73712 5.38107Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73126 5.34689L4.72217 5.29659L8.00243 4.70801L8.01124 4.75831L4.73126 5.34689Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72487 5.31397L4.71606 5.26339L7.99604 4.6748L8.00513 4.72539L4.72487 5.31397Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71902 5.27979L4.71021 5.22921L7.99018 4.64062L7.99927 4.69121L4.71902 5.27979Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71295 5.24631L4.70386 5.196L7.98412 4.60742L7.99321 4.65773L4.71295 5.24631Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70709 5.2131L4.698 5.16252L7.97826 4.57422L7.98707 4.62452L4.70709 5.2131Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70099 5.17921L4.69189 5.12862L7.97215 4.54004L7.98096 4.59063L4.70099 5.17921Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69485 5.14572L4.68604 5.09542L7.96601 4.50684L7.9751 4.55742L4.69485 5.14572Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68874 5.11154L4.67993 5.06124L7.95991 4.47266L7.969 4.52296L4.68874 5.11154Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68292 5.07834L4.67383 5.02775L7.95409 4.43945L7.9629 4.48976L4.68292 5.07834Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67682 5.04444L4.66772 4.99386L7.94798 4.40527L7.95679 4.45586L4.67682 5.04444Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67068 5.01096L4.66187 4.96065L7.94184 4.37207L7.95122 4.42266L4.67068 5.01096Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66482 4.97775L4.65601 4.92745L7.93598 4.33887L7.94507 4.38917L4.66482 4.97775Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65875 4.94357L4.64966 4.89299L7.92992 4.30469L7.93901 4.35499L4.65875 4.94357Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65265 4.91037L4.64355 4.86007L7.92381 4.27148L7.93262 4.32207L4.65265 4.91037Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64651 4.87619L4.6377 4.82589L7.91767 4.2373L7.92705 4.28761L4.64651 4.87619Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64065 4.84299L4.63184 4.7924L7.91181 4.2041L7.92091 4.25441L4.64065 4.84299Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63454 4.80909L4.62573 4.7585L7.90571 4.16992L7.9148 4.22051L4.63454 4.80909Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62872 4.7756L4.61963 4.7253L7.89989 4.13672L7.9087 4.18731L4.62872 4.7756Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62262 4.7424L4.61353 4.6921L7.89378 4.10352L7.90259 4.15382L4.62262 4.7424Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61648 4.70822L4.60767 4.65763L7.88764 4.06934L7.89673 4.11964L4.61648 4.70822Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61037 4.6753L4.60156 4.62472L7.88154 4.03613L7.89063 4.08644L4.61037 4.6753Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60455 4.64084L4.59546 4.59054L7.87572 4.00195L7.88481 4.05226L4.60455 4.64084Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59845 4.60764L4.58936 4.55733L7.86961 3.96875L7.87871 4.01905L4.59845 4.60764Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59259 4.57443L4.5835 4.52384L7.86375 3.93555L7.87256 3.98557L4.59259 4.57443Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5862 4.54025L4.57739 4.48995L7.85737 3.90137L7.86646 3.95196L4.5862 4.54025Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58038 4.50705L4.57129 4.45675L7.85155 3.86816L7.86064 3.91847L4.58038 4.50705Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57428 4.47287L4.56519 4.42228L7.84544 3.83398L7.85425 3.88429L4.57428 4.47287Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56842 4.43995L4.55933 4.38936L7.83959 3.80078L7.8484 3.85137L4.56842 4.43995Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56232 4.40549L4.55322 4.35518L7.83348 3.7666L7.84229 3.81719L4.56232 4.40549Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55617 4.37228L4.54736 4.32198L7.82734 3.7334L7.83643 3.7837L4.55617 4.37228Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55011 4.33908L4.54102 4.28849L7.82127 3.7002L7.83008 3.75021L4.55011 4.33908Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54425 4.30519L4.53516 4.2546L7.81541 3.66602L7.82422 3.7166L4.54425 4.30519Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53815 4.2717L4.52905 4.22139L7.80931 3.63281L7.81812 3.68312L4.53815 4.2717Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.532 4.23752L4.52319 4.18721L7.80317 3.59863L7.81226 3.64894L4.532 4.23752Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5259 4.2046L4.51709 4.15401L7.79706 3.56543L7.80616 3.61602L4.5259 4.2046Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52008 4.17042L4.51099 4.11983L7.79124 3.53125L7.80006 3.58184L4.52008 4.17042Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51398 4.13693L4.50488 4.08663L7.78514 3.49805L7.79395 3.54835L4.51398 4.13693Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50812 4.10373L4.49902 4.05314L7.779 3.46484L7.78809 3.51515L4.50812 4.10373Z",
    fill: "#6150DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74357 3.26704L4.46338 3.85547L4.50187 4.07003L7.78206 3.4816L7.74357 3.26704Z",
    fill: "#6150DC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4228_10290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.902344 0.198242)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCycon2);
export default __webpack_public_path__ + "static/media/small_cycon2.a8827f4f8efee7d5706bef3012d0a292.svg";
export { ForwardRef as ReactComponent };